<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import {
  urlMethods,
} from "@/state/helpers";
import Swal from "sweetalert2";
export default {
    components: {},
    data: function () {
        return {
            textEbill: "",
            isLoading: false,
        }
    },
    computed: {
        currentUser: function(){
            return this.$store.getters['auth/currentUser'];
        },
        currentTab: function(){
            return this.$store.getters['sale/currentTab'];
        },
        tabs: function(){
            return this.$store.getters['sale/tabs'];
        },
        ebill: {
            get: function() {
                return this.currentTab.ebill;
            },
            set: function(value) {
                this.$store.dispatch("sale/setEbill", value);
            },
        },
        totalAmount: function(){
            return typeof this.currentTab != 'undefined' && typeof this.currentTab.info != 'undefined' && typeof this.currentTab.info.totalAmount != 'undefined' ? this.currentTab.info.totalAmount : 0;
        },
        totalEbill: function() {
        return this.$store.getters["sale/totalEbill"];
        },
    },
    methods: {
        ...urlMethods,
        async searchEbill(){
            if(this.textEbill.length < 5) return false;
            this.isLoading = true;
            let that = this;
            try {
                for(const tab of this.tabs){
                    var hasEbill = tab.ebill.filter(item => item.name == this.textEbill);
                    if(typeof hasEbill != 'undefined' && typeof hasEbill.length != 'undefined' && hasEbill.length > 0){
                        throw 'Mã eBill đã được nhập trong Hoá đơn ' + tab.id;
                    }
                }
                let res = await this.postUrl({'url' : 'search-ebill', 'data' : {'code': this.textEbill}});
                if(typeof res == 'undefined' || typeof res.data == 'undefined'){
                    throw 'Không thế kết nối server';
                }
                if(!res.data){
                    throw 'Mã eBill không khả dụng';
                }
                this.$store.dispatch("sale/addEbill",res.data);
                this.textEbill = "";
                this.isLoading = false;
            } catch (error) {
                let text = (typeof error  == 'string' ? error : JSON.stringify(error));
                this.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
                this.isLoading = false;
            }
            setTimeout(() => {that.$refs.textEbill.focus();}, 100);
        },
        removeItem(item){
            this.$store.dispatch('sale/removeEbill',item);            
        }
    },
    mounted() {
        let that = this;
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            if(modalId == 'modal-ebill'){
                setTimeout(() => {
                    this.$refs.textEbill.focus();
                },300);
            }
        });
    },
};
</script>

<template>
<b-modal id="modal-ebill" title="Danh sách eBill" title-class="font-18" hide-footer>
    <div class="search-box">
        <div class="position-relative">
            <input type="text" ref="textEbill" class="form-control" :disabled="isLoading" v-model="textEbill" placeholder="Thêm mã eBill"  @keyup.enter="searchEbill" />
            <i class="bx bx-search-alt search-icon"></i>
            <div :class="(isLoading ? 'loading-box-search' : 'loading-box-search hidden')"><i class="fas fa-spinner fa-spin"></i></div>
        </div>
    </div>
    <div class="ebill-list">
        <div class="ebill-item" v-for="item in ebill" :key="item.name">
            <i class="bx bx-x remove-btn" @click="removeItem(item)"></i>
            <span class="ebill-name">{{ item.name }}</span>
            <span class="ebill-value">{{ item.value | VND }}</span>
        </div>
    </div>
    <div class="ebill-total">Tổng cộng: <b>{{ totalEbill | VND }}</b></div>
</b-modal>
</template>
